import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import 'react';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useQuery } from '@apollo/react-hooks';
import useAuthentication from 'hooks/use-authentication';
import GET_S2B_INTEGRATION from 'queries/get-s2b-information.graphql';
const S2BSumadi = () => {
    const location = useLocation();
    const { getExamIdFromToken, getUserIdFromToken } = useAuthentication();
    const { data, loading, refetch } = useQuery(GET_S2B_INTEGRATION, {
        variables: {
            fields: {
                userId: getUserIdFromToken(),
                examId: getExamIdFromToken()
            }
        }
    });
    const [s2bInformation, setS2bInformation] = useState('');
    useEffect(() => {
        if (!getUserIdFromToken() || !getExamIdFromToken()) {
            setS2bInformation('');
            return;
        }
        if (s2bInformation) {
            return;
        }
        refetch({
            fields: {
                userId: getUserIdFromToken(),
                examId: getExamIdFromToken()
            }
        });
    }, [getUserIdFromToken(), getExamIdFromToken(), location]);
    useEffect(() => {
        var _a, _b, _c;
        if (!data || !data.s2bInformation) {
            setS2bInformation('');
            return;
        }
        const payload = {
            lisPersonSourcedId: data.s2bInformation.studentId,
            lisPersonNameGiven: (_a = data.s2bInformation.firstName) !== null && _a !== void 0 ? _a : '',
            lisPersonNameFamily: (_b = data.s2bInformation.lastName) !== null && _b !== void 0 ? _b : '',
            lisPersonNameFull: (_c = data.s2bInformation.fullName) !== null && _c !== void 0 ? _c : '',
            customUserLocale: data.s2bInformation.language,
            customUserRole: data.s2bInformation.userRoleName,
            customUserEmail: data.s2bInformation.email,
            customUserId: data.s2bInformation.studentId,
            customCourseId: data.s2bInformation.courseId,
            customCourseName: data.s2bInformation.courseName,
            customAssesmentName: data.s2bInformation.examName,
            assesmentId: data.s2bInformation.examId,
            isExamProctored: data.s2bInformation.isProctored,
            examDateRange: {
                from: data.s2bInformation.availableAt,
                to: data.s2bInformation.closingAt
            }
            // This parameters will be needed on future
            // registerDateRange: {
            //   from: ,
            //   to:
            // }
        };
        const encoded = Buffer.from(JSON.stringify(payload)).toString('base64');
        setS2bInformation(encoded);
    }, [data]);
    return (_jsx(_Fragment, { children: !loading && s2bInformation !== '' && (_jsx("form", Object.assign({ id: 's2b-sumadi' }, { children: _jsx("input", { type: 'hidden', id: 's2bInformation', value: s2bInformation }, void 0) }), void 0)) }, void 0));
};
export default S2BSumadi;
